import {
  getToken,
  removeToken
} from '@/utils/auth';
import { cancelAllPending } from '@/utils/request';
import jwt_decode from 'jwt-decode';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import {
  Notify
} from 'vant';
import router from './router';
import store from './store';
NProgress.configure({
  showSpinner: false
})
const whiteList = ['/login', '/joinMatchmakerTeam', '/joinMatchMaker', '/', '/mbc', '/index', '/tagSelector']
const generalUserList = ['/login', '/joinMatchmakerTeam', '/mbc', '/', '/index', '/homePage', '/detail', '/matchmakerGroup', '/excellentMatchmaker', '/joinMatchMaker', '/activity', '/socialActivities', '/encounter', '/matchmakerList', '/favoriteMatchmaker', '/tagSelector']
const MemberList = ['/login', '/joinMatchmakerTeam', '/mbc', '/', '/index', '/homePage', '/detail', '/matchmakerGroup', '/excellentMatchmakerDetail',
  '/excellentMatchmaker', '/joinMatchMaker', '/checkInterests', '/editInfos', '/memberCenter', '/activity', '/socialActivities',
  '/memberBrowsingHistory', '/detailInformation', '/editFiled', '/tagSelector', '/emotionalStatusEdit', '/encounter',
  '/matchmakerList', '/favoriteMatchmaker', '/conversationList', '/chatRoom', '/mutualChoice', '/myFavoriteMembers'
];
const MatchmakerList = ['/login', '/mbc', '/', '/index', '/homePage', '/detail', '/matchmakerGroup', '/excellentMatchmaker', '/matchmakerCenter',
  '/checkInterests', '/detailInformation', '/followUpPage', '/followUpTargetSelector', '/followUpRecords', '/followUpRelationshipOverview', '/matchMakerInfo', '/lookFiled', '/editFiled', '/editMatchFiled', '/tagSelector',
  '/activity', '/socialActivities', '/matchmakerList', '/conversationList', '/chatRoom', '/myScore', '/mutualChoice', '/myFavoriteMembers'
];
const roleKey = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

router.beforeEach((to, from, next) => {
  // 路由切换时取消所有待处理请求，避免无效请求占用资源
  cancelAllPending();
  NProgress.start()
  // next()
  // return;
  if (getToken()) {
    /* has token*/
    if (to.path === '/login' || to.path === '/' || to.path === '/joinMatchmakerTeam' || to.path === '/joinMatchMaker') {
      NProgress.done()
      next()
    } else {
      let role;
      try {
        const jwtDecodeVal = jwt_decode(getToken());
        role = jwtDecodeVal[roleKey];
      } catch (e) {
        // token无效（如退会后端返回了非JWT格式的token），同步清除状态并跳转登录页
        removeToken();
        store.commit('SET_TOKEN', '')
        store.commit('SET_ROLES', '')
        store.commit('SET_INFOS', {})
        NProgress.done()
        next({ path: '/login' })
        return
      }
      store.dispatch("SET_ROLES", role)
      if (Object.keys(store.getters.baseInfo).length === 0 && !store.getters.getBaseInfo) {
        // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetInfo').then(res => {
          toRouters(role, to, next)
          // if (role === 'Member') {
          //   if (MemberList.indexOf('/'+to.name) !== -1) {
          //     next()
          //   } else {
          //     next({ path: '/homePage' })
          //   }
          // } else if (role === 'Matchmaker')  {
          //   if (MatchmakerList.indexOf('/'+to.name) !== -1) {
          //     next()
          //   } else {
          //     next({ path: '/homePage' })
          //   }
          // } else if (role === 'GeneralUser') {
          //   // 非会员没有用户信息，不进入判断
          //   if (generalUserList.indexOf('/'+to.name) !== -1) {
          //     next()
          //   } else {
          //     next({ path: '/homePage' })
          //   }
          // } else {
          //   next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          // }
          // })
        }).catch(err => {
          // 如果是路由切换取消的请求，静默处理
          if (err && err._canceled) return;
          // store.dispatch('LogOut').then(() => {
          Notify({
            type: 'danger',
            message: err
          });
          next({
            path: '/'
          })
          // })
        })
      } else {
        toRouters(role, to, next)
        // if (role === 'Member') {
        //   if (MemberList.indexOf('/'+to.name) !== -1) {
        //     next()
        //   } else {
        //     next({ path: '/homePage' })
        //   }
        // } else if (role === 'Matchmaker') {
        //   if (MatchmakerList.indexOf('/'+to.name) !== -1) {
        //     next()
        //   } else {
        //     next({ path: '/homePage' })
        //   }
        // }  else if (role === 'GeneralUser') {
        //   // 非会员没有用户信息，不进入判断
        //   if (generalUserList.indexOf('/'+to.name) !== -1) {
        //     next()
        //   } else {
        //     next({ path: '/homePage' })
        //   }
        // } else {
        //   next()
        // }
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf('/' + to.name) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
      NProgress.done()
    }
  }
})

router.afterEach((to, form) => {
  // if ((to.name !== 'matchmakerCenter' || to.name !== 'memberBrowsingHistory') && store.getters.queryListName !== 'query') {
  if (to.name !== 'matchmakerCenter' && to.name !== 'memberBrowsingHistory') {
    window.scrollTo(0, 0)
  }
  // 记录从活动页返回
  if (form.name === 'activity' && to.name === 'matchmakerCenter') {
    store.dispatch('SET_Activity', true);
  } else {
    store.dispatch('SET_Activity', false);
  }

  NProgress.done()
})

function toRouters(role, to, next) {
  if (role === 'Member') {
    if (MemberList.indexOf('/' + to.name) !== -1) {
      next()
    } else {
      next({
        // path: '/homePage'
        path: '/encounter'
      })
    }
  } else if (role === 'Matchmaker') {
    if (MatchmakerList.indexOf('/' + to.name) !== -1) {
      next()
    } else {
      next({
        // path: '/homePage'
        path: '/encounter'
      })
    }
  } else if (role === 'GeneralUser') {
    // 非会员没有用户信息，不进入判断
    if (generalUserList.indexOf('/' + to.name) !== -1) {
      next()
    } else {
      next({
        path: '/homePage'
      })
    }
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/permission.js